<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row>
              <el-col :md="10" :lg="10">
                <el-input :rows="1" placeholder="多个货号之间使用英文逗号 ',' 分隔" v-model="params.item_bns" clearable size="mini">
                  <el-button slot="append" icon="el-icon-search" @click="goodsSearch"></el-button>
                </el-input>
              </el-col>
              <el-col :md="10" :lg="10">
                <el-input :rows="1" placeholder="多个店铺ID之间使用英文逗号 ',' 分隔" v-model="params.inca_ids" clearable size="mini">
                  <el-button slot="append" icon="el-icon-search" @click="goodsSearch"></el-button>
                </el-input>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                只看售价不同：
                <el-switch v-model="params.is_diff" active-value="1" inactive-value="0"
                  @change="acitonIsDiff()" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>
              </el-col>
            </el-row>
            <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
                <el-table-column prop="item_id" label="商品ID" width="90"></el-table-column>
                <el-table-column prop="item_bn" label="商品货号" width="90"></el-table-column>
                <el-table-column prop="item_name" label="商品名称"></el-table-column>
                <el-table-column prop="number" label="店铺ID" width="90"></el-table-column>
                <el-table-column prop="name" label="店铺名称"></el-table-column>
                <el-table-column prop="market_price" label="商品售价" width="120">
                  <template slot-scope="scope">
                    ￥{{ scope.row.price / 100 }}
                  </template>
                </el-table-column>
                <el-table-column prop="area_market_price" label="SKU售价" width="120">
                  <template slot-scope="scope">
                    ￥{{ scope.row.sku_price / 100 }}
                  </template>
                </el-table-column>
            </el-table>
            <div class="content-center content-top-padded">
              <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[20,50,100,200,500]"
                  :total="total_count"
                  :page-size="params.pageSize">
              </el-pagination>
            </div>
        </div>
        <router-view></router-view>
    </div>
</template>
<script>
import { getItemSkuInfo } from '@/api/goods'
export default {
    data() {
      return {
        loading: false,
        params: {
          page: 1,
          pageSize: 20,
          item_bns: '',
          inca_ids: '',
          is_diff: '1',
        },
        total_count: 0,
        list: [],
      }
    },
    methods: {
      getItemSkuInfo() {
        this.loading = true
        console.log(this.params)
        getItemSkuInfo(this.params).then(res => {
          this.loading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
        })
      },
      goodsSearch() {
        this.params.page = 1
        this.getItemSkuInfo()
      },
      handleSizeChange(pageSize) {
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getItemSkuInfo()
      },
      handleCurrentChange(page_num) {
        this.params.page = page_num
        this.getItemSkuInfo()
      },
      acitonIsDiff() {
        this.params.page = 1
        this.getItemSkuInfo()
      },
    },
    mounted() {
      this.getItemSkuInfo()
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?7071fdc2